import script from "./OrderBookList.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderBookList.vue?vue&type=script&setup=true&lang=ts"

import "./OrderBookList.vue?vue&type=style&index=0&id=06919212&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06919212"]])

export default __exports__